import { OutputSortTypeEnum } from '@constant';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IStoreStandard } from '@types';

const initialState: IStoreStandard = {
  isIncludeUsed: true,
  isIncludeOtherUsersUsed: true,
  sortType: OutputSortTypeEnum.RANDOM,
  backgroundCut: null,
  characterNumber: null,
  frame: null,
  directed: null,
  verticalAngle: null,
  ageRange: null,
  mainMotionPart: null,
  facialExpression: null,
  deforme: null,
  horizontalAngle: null,
  postureCategory: null,
  skinship: null
};

export const standardSlice = createSlice({
  name: 'standard',
  initialState,
  reducers: {
    initStandard: () => {
      return initialState;
    },

    setStandard: (state, action: PayloadAction<Partial<IStoreStandard>>) => {
      return { ...state, ...action.payload };
    }
  }
});

export const { initStandard, setStandard } = standardSlice.actions;

export default standardSlice.reducer;
